import { configureStore } from '@reduxjs/toolkit'
import loadingReducer from './features/loading/loadingSlice'
// import authReducer from "./features/auth/authSlice"
import authReducer from "./features/auth/authSliceNew"
import cartReducer from "./features/Cart/CartSlice"
import wishlistReducer from './features/WishList/wishlistSlice'
import addressReducer from './features/address/addressSlice'
import couponReducer from './features/coupon/couponSlice'
import locationReducer from './features/location/locationSlice'
import petpoojaReducer from './features/petpooja/petpoojaSlice'

export const store = configureStore({
  reducer: {
    loader: loadingReducer,
    // auth: authReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    auth: authReducer,
    address: addressReducer,
    coupon: couponReducer,
    location: locationReducer,
    petpooja: petpoojaReducer,
  },
})

